import styled from 'styled-components';

export const ContainerSelect = styled.div`
  margin: 0px 3px;
`;
